import { ref, computed, watch } from 'vue'
import { darkTheme } from 'naive-ui'

export type ThemeMode = 'light' | 'dark'

const STORAGE_KEY = 'dozor_theme'

function readSystemPreference(): ThemeMode {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return 'light'
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

function readInitialMode(): ThemeMode {
  if (typeof localStorage === 'undefined') return 'light'
  const stored = localStorage.getItem(STORAGE_KEY) as ThemeMode | null
  if (stored === 'light' || stored === 'dark') return stored
  return readSystemPreference()
}

const mode = ref<ThemeMode>(readInitialMode())

function applyDataTheme(m: ThemeMode) {
  if (typeof document === 'undefined') return
  if (m === 'dark') {
    document.documentElement.setAttribute('data-theme', 'dark')
  } else {
    document.documentElement.removeAttribute('data-theme')
  }
}

applyDataTheme(mode.value)

watch(mode, (m) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, m)
  }
  applyDataTheme(m)
}, { flush: 'sync' })

const naiveTheme = computed(() => (mode.value === 'dark' ? darkTheme : null))

export function useTheme() {
  function toggle() {
    mode.value = mode.value === 'dark' ? 'light' : 'dark'
  }
  return { mode, toggle, naiveTheme }
}
